import { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";

const reduced = () =>
  typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Plays only while on screen (saves battery), shows a still frame when the
// visitor prefers reduced motion. `data` is an imported Lottie JSON.
export default function LottiePlayer({ data, label, className = "", loop = true, speed = 1, still = 110 }) {
  const wrap = useRef(null);
  const lottie = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = wrap.current;
    if (!node || !("IntersectionObserver" in window)) { setInView(true); return undefined; }
    const io = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.15 });
    io.observe(node);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const l = lottie.current;
    if (!l) return;
    l.setSpeed(speed);
    if (reduced()) { l.goToAndStop(still, true); return; }
    if (inView) l.play(); else l.pause();
  }, [inView, speed, still]);

  return (
    <div ref={wrap} className={className} role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <Lottie lottieRef={lottie} animationData={data} loop={loop} autoplay={false} style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
